import { render } from "./Trip.vue?vue&type=template&id=2ac899ce&scoped=true"
import script from "./Trip.vue?vue&type=script&lang=js"
export * from "./Trip.vue?vue&type=script&lang=js"

import "./Trip.vue?vue&type=style&index=0&id=2ac899ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac899ce"]])

export default __exports__